import React from 'react';
import Question6 from "../../Common/Question6/Question6";
var OverallGradeQuestionContent = function OverallGradeQuestionContent(_ref) {
  var formValidated = _ref.formValidated;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Question6, {
    formValidated: formValidated
  }));
};
export default OverallGradeQuestionContent;